/**
 * Location Formatting Helpers
 * Pure formatting utilities for location/distance display.
 */

/**
 * Formats airport distance as a rounded miles string.
 * @param {number} distance - Distance in miles (float)
 * @returns {string} "Approx. N miles away"
 */
export function formatAirportDistance(distance) {
  return `Approx. ${Math.round(distance)} miles away`;
}

/**
 * Formats infrastructure distance to one decimal place.
 * @param {number} distance - Distance in miles (float)
 * @returns {string} "X.Y mi"
 */
export function formatInfraDistance(distance) {
  return `${distance.toFixed(1)} mi`;
}

/**
 * Truncates a name to maxLen characters with ellipsis.
 * @param {string} name - The name to truncate
 * @param {number} maxLen - Maximum length before truncation (default 50)
 * @returns {string} Original name if ≤ maxLen, otherwise first maxLen chars + "..."
 */
export function truncateName(name, maxLen = 50) {
  if (!name) return "";
  if (name.length <= maxLen) return name;
  return name.slice(0, maxLen) + "...";
}
